import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms'; // For ngModel
import { GlobalFilterService } from '../../shared-services/global-filter-service';
import { HttpClient } from '@angular/common/http';

// Import Angular Material modules
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { WidgetActionService } from '../../shared-services/widget-action.service';


import { Subscription } from 'rxjs';

@Component({
  selector: 'app-side-entity-form',
  standalone: true, // Make it standalone
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatSnackBarModule,
    MatProgressSpinnerModule
 
  ],
  templateUrl: './side-entity-form.component.html',
  styleUrls: ['./side-entity-form.component.scss'] // Use styleUrls
})
export class SideEntityFormComponent implements OnInit, OnDestroy {
  @Input() data:any;

  // Local copy of the record for editing
  editableRecord: any = null;
  originalRecord: any = null;
  // formFields: { key: string, label: string }[] = [];
  formFields: { key: string; label: string; type: 'text' | 'dropdown' }[] = [];

  sectionTitle: string = 'Details'; // Default title
  isSaving: boolean = false;
  loading: boolean = false;
  selectedEntityName: string | null = null;
  dropdownOptions: Record<string, any[]> = {};
  dropdownLoading: Record<string, boolean> = {};




  private recordFilterSubscription!: Subscription; // Renamed for clarity
  private dropdownFilterSubscription!: Subscription; // New subscription for dropdowns
  private loadingSubscription!: Subscription;


  constructor(
    private globalFilterService: GlobalFilterService,
    private http: HttpClient,
    private snackBar: MatSnackBar,
    private widgetActionService: WidgetActionService
  ){

  }
  ngOnInit(): void {
    // Subscription for selected record from entity-table (widget1)
    const recordFilterListeners: string[] = this.data?.filterListner || [];
    // if (recordFilterListeners.length > 0) {
    //   this.recordFilterSubscription = this.globalFilterService.filter$.subscribe(filterData => {
    //     if (recordFilterListeners.includes(filterData.changedFilterKey)) {
    //       const selectedRecord = filterData.requestParams[filterData.changedFilterKey];
    //       if (selectedRecord && selectedRecord.length > 0) {
    //         this.originalRecord = selectedRecord[0];
    //         this.editableRecord = { ...this.originalRecord };
    //         this.generateFormFieldsFromRecord();
    //       }
    //     }
    //   });
    // }

    if (recordFilterListeners.length > 0) {
  this.recordFilterSubscription = this.globalFilterService.filter$.subscribe(filterData => {
    if (recordFilterListeners.includes(filterData.changedFilterKey)) {
      const selectedRecord = filterData.requestParams[filterData.changedFilterKey];
      if (selectedRecord && selectedRecord.length > 0) {

        this.originalRecord = selectedRecord[0];
        this.editableRecord = { ...this.originalRecord };
        this.generateFormFieldsFromRecord();

        // 🔽 ADD THIS BLOCK HERE (EXACT PLACE)
        if (this.editableRecord?.ecc) {
          const engineCfg = this.data?.formFieldConfig?.engine_model;
          if (engineCfg?.api) {
            this.fetchDropdownOptions('engine_model', engineCfg.api);
          }
        }
        // 🔼 END ADD

      }
    }
  });
}


    this.loadingSubscription = this.globalFilterService.filter$.subscribe(filterData => {
      if (filterData.widgetId === 'widget1' && filterData.changedFilterKey === 'loading') {
        const loadingState = filterData.requestParams['loading'];
        if (loadingState && loadingState.length > 0) {
          this.loading = loadingState[0];
        }
      }
    });

    // Subscription for dynamic section title from dropdown in entity-management
    // Assuming the dropdown key for 'Entity' is 'entity'
    this.dropdownFilterSubscription = this.globalFilterService.filter$.subscribe(filterData => {
      if (filterData.changedFilterKey === 'entity') { // Listen for 'entity' dropdown changes
        const selectedEntity = (filterData.queryParams?.['entity'] || filterData.requestParams?.['entity']);
        if (selectedEntity && selectedEntity.length > 0) {
          this.selectedEntityName = selectedEntity[0];
          this.sectionTitle = selectedEntity[0]; // Update title with selected entity
          console.log('Selected entity:', this.selectedEntityName);
        }
      }
    });

    // Initial record if provided
    if (this.data?.record) {
      this.originalRecord = this.data.record;
      this.editableRecord = { ...this.originalRecord };
      this.generateFormFieldsFromRecord();
    }
    
    // Set initial title from config if available, otherwise default
    if (this.data?.sections?.[0]?.title) {
      this.sectionTitle = this.data.sections[0].title;
    }

    this.widgetActionService.action$.subscribe(event => {
      console.log('Received widget action event in SideEntityFormComponent:', event);
       console.log('Event received:', event);
  console.log('Form widget data:', this.data);
  console.log('actionListener:', this.data?.actionListener);
  console.log('sourceWidgetId:', event.sourceWidgetId);

  // 1️⃣ Check JSON-driven listener rule
  if (
    !this.data?.actionListener ||
    !this.data.actionListener.includes(event.sourceWidgetId)
  ) {
     console.log('Guard blocked execution');
    return;
  }
    console.log('✅ Guard passed');

      if (event.actionId === 'add') {
    console.log('➡️ Calling openNewForm()');
    this.openNewForm();
  }

  // 2️⃣ React to navbar actionId
  switch (event.actionId) {

    case 'add':
       console.log('➡️ Calling openNewForm()');
      this.openNewForm();
      break;
  }
});

  }


//   openNewForm(): void {
//   console.log('Opening new form');
//   this.originalRecord = null;
//   this.editableRecord = {test:''};
//   this.generateFormFieldsFromRecord();
// }
openNewForm(): void {
  console.log('Opening new form');

  if (this.originalRecord) {
    this.editableRecord = {};
    Object.keys(this.originalRecord).forEach(key => {
      if (key !== 'id') {
        this.editableRecord[key] = '';
      }
    });
    this.generateFormFieldsFromRecord();
  }
}


reloadForm(): void {
  console.log('Reloading form 1');
  if (this.originalRecord) {
    console.log('Original record exists, reloading it');
    this.editableRecord = { ...this.originalRecord };
  }
}

prepareDelete(): void {
  this.snackBar.open(
    'Delete triggered from navbar',
    'Close',
    { duration: 3000 }
  );
}

  
  // private generateFormFieldsFromRecord(): void {
  //   if (!this.editableRecord) {
  //     this.formFields = [];
  //     return;
  //   }
    
  //   this.formFields = Object.keys(this.editableRecord)
  //     .filter(key => key !== 'id') // Optional: filter out keys like 'id'
  //     .map(key => ({
  //       key: key,
  //       label: this.toTitleCase(key)
  //     }));
  // }

  private generateFormFieldsFromRecord(): void {
  if (!this.editableRecord) {
    this.formFields = [];
    return;
  }

  const fieldConfig = this.data?.formFieldConfig || {};

  this.formFields = Object.keys(this.editableRecord)
    .filter(key => key !== 'id')
    .map(key => ({
      key,
      label: fieldConfig[key]?.label || this.toTitleCase(key),
      type: fieldConfig[key]?.type || 'text'
    }));

  this.loadDropdownData();
}

private loadDropdownData(): void {
  const config = this.data?.formFieldConfig || {};

  Object.keys(config).forEach(fieldKey => {
    if (config[fieldKey]?.type === 'dropdown') {
      this.fetchDropdownOptions(fieldKey, config[fieldKey].api);
    }
  });
}


private fetchDropdownOptions(fieldKey: string, api: any): void {
  if (!api?.url) return;

  this.dropdownLoading[fieldKey] = true;

  let payload = JSON.stringify(api.payload || {});

  payload = payload
    .replace('{entity}', this.selectedEntityName || '')
    .replace('{ecc}', this.editableRecord?.ecc || '');

  const finalPayload = JSON.parse(payload);

  this.http.request(api.method || 'POST', api.url, {
    body: finalPayload
  }).subscribe({
    next: (res: any) => {
      const data = res?.[api.responseKey] || [];
      this.dropdownOptions[fieldKey] = data.map((item: any) => ({
        value: item[api.valueField],
        label: item[api.displayField]
      }));
      this.dropdownLoading[fieldKey] = false;
    },
    error: () => {
      this.dropdownLoading[fieldKey] = false;
    }
  });
}



  private toTitleCase(str: string): string {
    // This helper function converts snake_case and camelCase to Title Case
    str = str.replace(/_/g, ' ');
    str = str.replace(/([a-z])([A-Z])/g, ' $2');
    return str.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
  }

  ngOnDestroy(): void {
    if (this.recordFilterSubscription) {
      this.recordFilterSubscription.unsubscribe();
    }
    if (this.dropdownFilterSubscription) {
      this.dropdownFilterSubscription.unsubscribe();
    }
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
    }
  }

  resetForm(): void {
    if (this.originalRecord) {
      this.editableRecord = { ...this.originalRecord }; // Reset from original
    } else {
      this.editableRecord = null;
    }
  }

  saveForm(action: any): void {
    console.log('Original record for saving:', this.originalRecord);
    if (this.editableRecord && this.originalRecord && action.apiUrl) {
      this.isSaving = true;

      const changedData: any = {};
      let hasChanges = false;

      // Add ID if it exists in the original record
      if (this.originalRecord.id) {
        changedData.id = this.originalRecord.id;
      }

      // for (const key in this.editableRecord) {
      //   // Ensure not to add 'id' as a changed field if it's already in changedData
      //   if (key !== 'id' && this.editableRecord.hasOwnProperty(key) && this.editableRecord[key] !== this.originalRecord[key]) {
      //     changedData[key] = this.editableRecord[key];
      //     hasChanges = true;
      //   }
      // }
      for (const key in this.editableRecord) {
  if (
    key !== 'id' &&
    this.editableRecord[key] !== this.originalRecord[key]
  ) {
    hasChanges = true;
    break;
  }
}

      if (!hasChanges) {
        this.isSaving = false;
        this.snackBar.open('No changes to save.', 'Close', { duration: 3000 });
        return;
      }
  
      console.log('Saving changed data:', changedData);
    const entityKey:any = this.selectedEntityName ;
    console.log('Entity Key for saving:', entityKey);
    let payload: any = {};
    let FinalEntityKey: any;
    let endpoint: any;
    let WorkFlowId: any;
    if(entityKey==="part"){
      FinalEntityKey="part";
      endpoint=[
    {
      functionName: 'PartInsertUpdateService',
      version: '1.0'
    },
    {
      functionName: "DnPricingInsertUpdateService",
      version: "1.0"
    }
  ];
  WorkFlowId= "DN_PRICING_WORKFLOW_001";
    }
    else if(entityKey==="dn_pricing") {
      FinalEntityKey="dn_pricing";
      endpoint=[
          {
      functionName: "DnPricingAction",
      version: "1.0"
    }
      ];
      WorkFlowId= "DN_PRICING_WORKFLOW_001";
    }

      payload = {
  requestData: {
    source: 'UI',
    [entityKey]: [
      {
       ...this.editableRecord
      }
    ]
  },
  responseList: [],
  entity: FinalEntityKey,
  workflowId: WorkFlowId,
  endpoints: endpoint,
  communicationType: 'rest',
  version: '1.0'
};

console.log('Final Save Payload:', payload);
      const method = action.method || 'POST';
      this.http.request(method, action.apiUrl, { body: payload }).subscribe({
        next: (response) => {
          this.isSaving = false;
          console.log('Save successful', response);
          this.snackBar.open('Saved successfully!', 'Close', {
            duration: 3000,
            panelClass: ['success-snackbar']
          });
          // After saving, update the original record to match the new state
          this.originalRecord = { ...this.editableRecord };
          if (action.refreshWidgets && Array.isArray(action.refreshWidgets)) {
            action.refreshWidgets.forEach((widgetId: string) => {
              this.globalFilterService.requestWidgetRefresh(widgetId);
            });
          }
        },
        error: (error) => {
          this.isSaving = false;
          console.error('Save failed', error);
          this.snackBar.open('Error saving data.', 'Close', {
            duration: 3000,
          });
        },
      });
    }
  }

  handleAction(actionId: string): void {
    const action = this.data?.sections
      ?.flatMap((s: any) => s.actions)
      .find((a: any) => a.actionId === actionId);

    if (action) {
      if (actionId === 'reset') {
        this.resetForm();
      } else if (actionId === 'save') {
        this.saveForm(action);
      }
    }
  }
}